<template>
  <form-layout
    class="user-form"
    entity-name="user"
    :loading="isLoading"
    @save="saveUser"
  >
    <template #title>
      <h1 class="uppercase">{{ titleText }}</h1>
    </template>
    <template #body>
      <bdg-text-field name="Name" v-model="userData.name" required />

      <bdg-dropdown
        name="Type"
        :options="types"
        v-model="userData.type"
        required
      />

      <bdg-text-field name="Email" v-model="userData.email" required />

      <template
        v-if="
          userData.type === UserTypes.CREW_LEADER ||
            userData.type === UserTypes.CREW_SUPERVISOR
        "
      >
        <bdg-phone-number-field
          name="Primary phone"
          v-model="userData.primary_phone"
        />

        <bdg-phone-number-field
          :name="`Additional phone ${i + 1}`"
          v-model="userData.additional_phones[i]"
          @remove="removePhoneNumber(i)"
          :key="`additional_phone_${i}`"
          v-for="(phone, i) in userData.additional_phones"
          removable
        />

        <bdg-add-field
          add-text="Add phone"
          :new-value="newPhoneNumber()"
          v-model="userData.additional_phones"
        />
      </template>

      <bdg-password-field
        name="Password"
        v-model="userData.password"
        required
      />
      <p class="text-xs" v-if="id">
        (blank to leave unchanged)
      </p>
    </template>
  </form-layout>
</template>

<script>
import FormLayout from "../views/layouts/FormLayout";
import BdgTextField from "./fields/BdgTextField";
import BdgDropdown from "./fields/BdgDropdown";
import BdgPasswordField from "./fields/BdgPasswordField";
import { UserTypeLabels, UserTypes } from "../constants/user-enums";
import BdgPhoneNumberField from "./fields/BdgPhoneNumberField";
import BdgAddField from "./fields/BdgAddField";
import { Phone } from "../models/Phone";

export default {
  name: "UserForm",
  components: {
    BdgAddField,
    BdgPhoneNumberField,
    BdgPasswordField,
    BdgDropdown,
    BdgTextField,
    FormLayout
  },
  props: {
    id: Number,
    name: { type: String, default: "" },
    type: { type: String, default: UserTypes.ADMIN },
    email: { type: String, default: "" },
    password: String,
    primary_phone: {
      type: Phone,
      default: () => new Phone()
    },
    additional_phones: { type: Array, default: () => [] }
  },
  data() {
    return {
      userData: {
        id: this.id,
        name: this.name,
        type: this.type,
        email: this.email,
        password: this.password,
        primary_phone: this.primary_phone,
        additional_phones: this.additional_phones.slice()
      },
      UserTypes,
      types: Object.values(UserTypes).map(slug => {
        return { label: UserTypeLabels[slug], value: slug };
      })
    };
  },
  computed: {
    titleText() {
      return this.id ? "Edit User" : "Create New User";
    },
    isStoringUser() {
      return this.$store.state.Users.isStoringUser;
    },
    isUpdatingUser() {
      return this.$store.state.Users.isUpdatingUser;
    },
    isLoading() {
      return this.id ? this.isUpdatingUser : this.isStoringUser;
    }
  },
  methods: {
    newPhoneNumber() {
      return new Phone();
    },
    removePhoneNumber(index) {
      this.userData.additional_phones.splice(index, 1);
    },
    saveUser() {
      if (this.id) {
        this.$store.dispatch("updateUser", this.userData);
      } else {
        this.$store.dispatch("storeUser", this.userData);
      }
    }
  }
};
</script>
